import { render, staticRenderFns } from "./DeductiblesList.vue?vue&type=template&id=19326a84"
import script from "./DeductiblesList.vue?vue&type=script&lang=js"
export * from "./DeductiblesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports